import { render, staticRenderFns } from "./promotions-deposit.vue?vue&type=template&id=090c369a"
import script from "./promotions-deposit.vue?vue&type=script&lang=js"
export * from "./promotions-deposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/promotions/promotions-deposit.vue
// module id = d31t
// module chunks = 0